module.exports = __webpack_public_path__ + "img/Availability Tracking.63dafcde.svg";